import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

export const RealizationsShowcaseSection = ({
  project,
  images,
  autoPlay = false,
}) => {
  const { t } = useTranslation();
  const [thumbnailPosition, setThumbnailPosition] = useState("right");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) setThumbnailPosition("bottom");
      else setThumbnailPosition("right");
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="realizations-section">
      <h1>{t(`realizations.${project}.title`)}</h1>
      <br />
      <br />
      <div className="showcase-container">
        <ImageGallery
          items={images}
          lazyLoad={true}
          infinite={true}
          showFullscreenButton={true}
          showPlayButton={true}
          showBullets={false}
          showThumbnails={true}
          showNav={true}
          showIndex={true}
          autoPlay={autoPlay}
          slideInterval={5000}
          slideDuration={450}
          thumbnailPosition={thumbnailPosition}
        />
        <div className="showcase-description">
          <p>
            <Trans t={t} i18nKey={`realizations.${project}.description`} />
          </p>
        </div>
      </div>
    </section>
  );
};
